import {useFlags, useFlagsLoaded} from '@product-web/flags'

import type {PlanSelectionModalProps} from './plan-selection-modal'
import {PlanSelectionModal} from './plan-selection-modal'

import {bff} from '../bff-hooks'
import {isOnNewPricingPlan} from '../helpers'
import {ChoosePlanContainer} from '../manage-plan/choose-plan-container'

export const PlanSelectionModalWrapper = (props: PlanSelectionModalProps) => {
    const {newPlanSelectionModal} = useFlags()
    const flagsLoaded = useFlagsLoaded()
    const {data: companySubscription, isLoading: isCompanySubscriptionLoading} =
        bff.paywall.planSelectionModal.getCompanySubscription.useQuery()

    if (!flagsLoaded || isCompanySubscriptionLoading) {
        return null
    }

    if (newPlanSelectionModal && isOnNewPricingPlan(companySubscription?.platformRatePlan.type)) {
        return <PlanSelectionModal {...props} />
    }

    return <ChoosePlanContainer {...props} trackingOrigin={props.pageSection} />
}
